import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={9}
        height={16}
        viewBox="0 0 9 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.40285 15.6534V8.51317H0V5.73047H2.40285V3.6783C2.40285 1.29678 3.8574 0 5.98188 0C6.99953 0 7.87415 0.0757662 8.12903 0.109631V2.59846L6.65559 2.59913C5.50018 2.59913 5.27646 3.14816 5.27646 3.95383V5.73047H8.03201L7.67323 8.51317H5.27646V15.6534H2.40285Z"
            fill="white"
        />
    </svg>
);

const FaceBookLogo = React.memo(SVGComponent)
export default FaceBookLogo;
